import { useMutation } from '@tanstack/react-query';
import { ICalendarMeetingsWithTranscriptsResponse } from '../../../viewmodels/CalendarViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useAdminCalendarMeetingTranscriptsMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			userId,
			accountId,
			userEmail,
			startDate,
			endDate,
		}: {
			userId: string;
			accountId: string;
			userEmail: string;
			startDate: Date;
			endDate: Date;
		}) => {
			// Convert dates to UTC for API call
			const startDateUtc = new Date(
				Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)
			);
			const endDateUtc = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59));

			const url = `admin/calendar/meetings/match-transcripts?userId=${encodeURIComponent(userId)}&accountId=${encodeURIComponent(accountId)}&userEmail=${encodeURIComponent(userEmail)}&startDate=${startDateUtc.toISOString()}&endDate=${endDateUtc.toISOString()}`;

			return userSession.webServiceHelper.callAsync<ICalendarMeetingsWithTranscriptsResponse>(url, 'POST');
		},
	});
}
